import React, { useState, useRef, useEffect } from 'react';
import { useCurrency } from '../../../context/CurrencyContext';
import './CurrencySwitcher.css';

const currencies = [
  { code: 'USD', name: 'US Dollar' },
  { code: 'BHD', name: 'Bahraini Dinar' },
];

const CurrencySwitcher = () => {
  const { currency, changeCurrency } = useCurrency();
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  const currentCurrency = currency || 'USD';

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') setIsOpen(false);
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, []);

  const selectCurrency = (code) => {
    changeCurrency(code);
    setIsOpen(false);
  };

  return (
    <div className="csw-wrapper">
      <div className="csw-dropdown" ref={wrapperRef}>
        <button
          type="button"
          className="csw-button"
          onClick={() => setIsOpen(!isOpen)}
          aria-expanded={isOpen}
          aria-label="Change currency"
        >
          {currentCurrency}
          <svg className={`csw-arrow ${isOpen ? 'open' : ''}`} viewBox="0 0 12 8" aria-hidden="true">
            <path d="M1.5 1.75 6 6.25l4.5-4.5" />
          </svg>
        </button>

        {isOpen && (
          <ul className="csw-menu" role="listbox">
            {currencies.map(({ code, name }) => (
              <li key={code}>
                <button
                  type="button"
                  role="option"
                  aria-selected={currentCurrency === code}
                  className={`csw-menu-item ${currentCurrency === code ? 'active' : ''}`}
                  onClick={() => selectCurrency(code)}
                >
                  <span className="csw-code">{code}</span>
                  <span className="csw-name">{name}</span>
                  {currentCurrency === code && (
                    <svg className="csw-check" viewBox="0 0 12 10" aria-hidden="true">
                      <path d="M1.5 5.25 4.5 8.25 10.5 1.75" />
                    </svg>
                  )}
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default CurrencySwitcher;
